import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import {initialState} from './Shared/Constants';

export const GetTransactionSummaryData = createAsyncThunk('cellcomTransactionSummary/GetTransactionSummaryData', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('getTransactionSummaryData', [data.guidId]);
    return {
      isSuccess: true,
      transactionData: result.Body,
      errorCode: result.Header.ReturnCode == '0' ? '00' : result.Header.ReturnCode,
    };
  } catch (error) {
    return {isSuccess: false, errorCode: '19'};
  }
});

// fill info according to relevant data - without cms data
/* interface TransactionSummaryState {
}
 */

const transactionSummaryBlockSlice = createSlice({
  name: 'cellcomTransactionSummary',
  initialState,
  reducers: {
    setSubscriber: (state, action) => {
      state.callular = action.payload;
    },
  },
  extraReducers: {
    [GetTransactionSummaryData.fulfilled]: (state, action) => {
      state.isSuccess = action.payload.isSuccess;
      state.errorCode = action.payload.errorCode;
      state.transactionData = action.payload.transactionData;
      state.callular = action.payload.transactionData?.generalDetails?.subscriberNumberList[0];
    },
  },
});

export const {setSubscriber} = transactionSummaryBlockSlice.actions;
export default transactionSummaryBlockSlice.reducer;
